export enum ProhibitedIban {
  DCF = 'FR7630076021631398570020014',
  WEBIMM = 'FR7630076021631327200020002',
  UNKNOW = 'FR7600000000000000000000000'
}
